import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { NotificationItemRow } from './NotificationItemRow';
import { NotificationRowError } from './NotificationRowError';
import { NotificationRowSkeleton } from './NotificationRowSkeleton';
import useLead from '~/features/leadDetails/hooks/useLead';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';
import { dateFormat, timeFormat } from '~/lib/i18n';

type Props = {
    loanRequestId: string;
    resubmissionAt: number;
    processedAt: number;
    onNavigate?: () => void;
};

export const ProcessedResubmissionRow: React.FC<Props> = ({
    loanRequestId,
    onNavigate,
    processedAt,
    resubmissionAt,
}) => {
    const { t } = useTranslation();
    const { data: lead, isError, isLoading } = useLead(loanRequestId);

    if (isLoading) return <NotificationRowSkeleton />;
    if (isError) return <NotificationRowError />;
    if (!lead?.antragsteller1) return null;

    return (
        <NotificationItemRow
            previewName={`${lead.antragsteller1.personendaten?.vorname ?? ''} ${
                lead.antragsteller1.personendaten?.nachname ?? ''
            }`.trim()}
            previewDetail={`${dateFormat(new Date(resubmissionAt))} - ${timeFormat(new Date(resubmissionAt))} ${t(
                'TOP_HEADER.NOTIFICATIONS.DATE',
            )}`}
            timestamp={processedAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.RESUBMISSION, loanRequestId)}
            onNavigate={onNavigate}
        />
    );
};
